import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { errorsMapping } from '../../mappers/errors-mapping.js';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import { SET_STORE } from '../../operations/mutations/set-store.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import { getFlattenedCartFailureErrorCodes } from '../../utils/get-flattened-cart-error-codes.js';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '@grandvisionhq/utils';
import '../../utils/has-cart-errors.js';
import { useMutationConfig } from './use-mutation-config.js';
import { useUpdateCartCache } from './use-update-cart-cache.js';

const useSetStore = ({ onError , onCompleted  } = {})=>{
    const [cart] = useCartStorage();
    const { updateCacheWithCart  } = useUpdateCartCache();
    /**
   * Handle success and error response from mutation operation
   * @param responseData
   */ const handleOnCompleted = React.useCallback((responseData)=>{
        let result;
        if ('setStore' in responseData) {
            var ref;
            result = responseData.setStore;
            if ((ref = result.failures) === null || ref === void 0 ? void 0 : ref.length) {
                const errorCodes = getFlattenedCartFailureErrorCodes(result.failures);
                onError === null || onError === void 0 ? void 0 : onError({
                    reason: 'MUTATION'
                });
                /**
           *  Notify user about all failures
           *  To handle granular errors return from mutation operation
           */ errorCodes.forEach((error)=>toast.failed(error)
                );
            }
            if (result.success) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
            }
        }
    }, [
        onCompleted,
        onError
    ]);
    const handleOnError = React.useCallback(()=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        onError
    ]);
    const { mutationOptions  } = useMutationConfig({
        onError: handleOnError,
        onCompleted: handleOnCompleted
    });
    const updateCache = React.useCallback((cache, { data  })=>{
        if (data && data.setStore.success) {
            const updatedCart = data.setStore.cart;
            updatedCart && updateCacheWithCart({
                cart: updatedCart,
                cache
            });
        }
    }, [
        updateCacheWithCart
    ]);
    const [mutationCallback, mutation] = useMutation(SET_STORE, swcHelpers.objectSpread({}, mutationOptions, {
        // reason: typescript complains about a typing mismatch for the data prop
        update: updateCache,
        context: {
            forwardHeaders: {
                'cart-hash': cart.cartHash
            }
        }
    }));
    /**
   *  Store data update operation
   *  @param storeCode: number
   */ const setStore = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(storeCode) {
            if (!cart.cartId) {
                console.error('Cart ID is missing');
                return;
            }
            yield mutationCallback({
                variables: {
                    storeInput: {
                        code: storeCode,
                        checkoutId: cart.cartId
                    }
                }
            });
        });
        return function(storeCode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutationCallback,
        cart.cartId
    ]);
    return {
        setStore,
        isUpdating: mutation.loading,
        updateError: mutation.error,
        called: mutation.called
    };
};

export { useSetStore };
//# sourceMappingURL=use-set-store.js.map
